import { SupportedLocale } from '../enums/supported-locale.enum';
export const GENDERED_LOCALES = new Set([
    SupportedLocale.POLISH,
    SupportedLocale.FRENCH,
    SupportedLocale.SPANISH_LATIN_AMERICAN,
    SupportedLocale.ITALIAN,
    SupportedLocale.PORTUGUESE_BRAZILIAN,
    SupportedLocale.BULGARIAN,
    SupportedLocale.SPANISH_EUROPEAN,
]);
